//  Core
import Mmenu        from "../../libs/mmenu/dist/core/oncanvas/mmenu.oncanvas";

//  Core add-ons
import offcanvas    from "../../libs/mmenu/dist/core/offcanvas/mmenu.offcanvas";
import screenReader from "../../libs/mmenu/dist/core/screenreader/mmenu.screenreader";
import scrollBugFix from "../../libs/mmenu/dist/core/scrollbugfix/mmenu.scrollbugfix";

//  Add-ons
import counters     from "../../libs/mmenu/dist/addons/counters/mmenu.counters";
import navbars      from "../../libs/mmenu/dist/addons/navbars/mmenu.navbars";

//  Wrappers
import bootstrap    from "../../libs/mmenu/dist/wrappers/bootstrap/mmenu.bootstrap";

Mmenu.addons = {
    //  Core add-ons
    offcanvas,
    screenReader,
    scrollBugFix,

    //  Add-ons
    counters,
    navbars
};

//  Wrappers
Mmenu.wrappers = {
    bootstrap
};

//    Global namespace
window.Mmenu = Mmenu

export default class MobileMenu {
    constructor() {
        document.addEventListener(
            "DOMContentLoaded", () => {
                const menu = new Mmenu("#mobile-menu", {
                    // options
                    panel: 'page_wrapper',
                    slidingSubmenus: false,
                    extensions: ["fullscreen", "position-right", "position-front"],
                    keyboardNavigation: true,
                    scrollBugFix: { 
                        fix: false
                    },
                    navbar: {
                        add: false
                    }
                }, {
                    // configuration
                    classNames: {
                        selected: "active"
                    }, 
                    screenReader: {
                        text: {
                            closeMenu: "Stäng Meny",
                            closeSubmenu: "Stäng undermeny",
                            openSubmenu: "Öppna undermeny",
                            toggleSubmenu: "Öppna/stäng undermeny"
                        }
                    }
                });
                const api = menu.API;

                document.querySelector(".item-hamburger").addEventListener("click", (event) => {
                    event.preventDefault();
                    api.open();
                });
                document.querySelector(".mm-close").addEventListener("click", (event) => {
                    event.preventDefault();
                    api.close();
                });
            }
        );
    }
}